module.exports = __webpack_public_path__ + "static/media/KH.e851545e.svg";